<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
import PipelineStagesAPI from 'dashboard/api/pipelineStages';

export default {
  components: {
    MultiselectDropdown,
  },
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      pipelineStages: [],
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    assignedPipelineStage: {
      get() {
        const currentStage =
          this.currentChat?.custom_attributes?.pipeline_stage;
        const selectedOption = this.pipelineStages.find(
          opt => String(opt.id) === String(currentStage)
        );
        // Sem estágio → objeto vazio: o MultiselectDropdown mostra o placeholder.
        return selectedOption || {};
      },
      set(stageItem) {
        const stage = stageItem.id;
        const fromStage = this.currentChat?.custom_attributes?.pipeline_stage;

        this.$store
          .dispatch('pipeline/updateStage', {
            conversationId: this.conversationId,
            stage,
            fromStage,
          })
          .then(() => {
            // Update the current conversation in the store with the new pipeline stage
            if (this.currentChat && this.currentChat.id) {
              const updatedChat = {
                ...this.currentChat,
                custom_attributes: {
                  ...this.currentChat.custom_attributes,
                  pipeline_stage: stage,
                },
              };
              this.$store.commit('UPDATE_CONVERSATION', updatedChat);
            }

            useAlert(
              this.$t('PIPELINE.API.SUCCESS_MESSAGE', {
                stage: stageItem.name,
              })
            );
          })
          .catch(error => {
            console.error('Error updating pipeline stage:', error);
            useAlert(error.message || this.$t('PIPELINE.API.ERROR_MESSAGE'));
          });
      },
    },
  },
  methods: {
    async loadPipelineStages() {
      try {
        const response = await PipelineStagesAPI.get();
        this.pipelineStages = response.data;
      } catch (error) {
        console.error('Error loading pipeline stages:', error);
      }
    },
    // O lead nunca sai do funil por aqui: só troca de coluna. A saída é por Ganho/Perda,
    // que o backend trata (zera o pipeline_stage ao fechar o negócio). Antes existia uma
    // opção "None" na lista E o clique no estágio já selecionado desmarcava — os dois
    // tiravam a conversa de TODA pasta, em silêncio (24 ocorrências medidas em produção).
    onClickAssignStage(selectedStageItem) {
      if (this.assignedPipelineStage.id === selectedStageItem.id) return;
      this.assignedPipelineStage = selectedStageItem;
    },
  },
  mounted() {
    this.loadPipelineStages();
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <MultiselectDropdown
      :options="pipelineStages"
      :selected-item="assignedPipelineStage"
      :multiselector-title="$t('CONVERSATION_SIDEBAR.ACCORDION.PIPELINE_STAGE')"
      :multiselector-placeholder="$t('PIPELINE.SELECT_PLACEHOLDER')"
      :no-search-result="$t('PIPELINE.NO_RESULTS')"
      :input-placeholder="$t('PIPELINE.INPUT_PLACEHOLDER')"
      @select="onClickAssignStage"
    />
  </div>
</template>
